import React from 'react';
import ContentfulIntegrationTable from '../../../../components/ContentfulIntegration/ContentfulIntegrationTable';
import { useContentfulContext } from '../../../../contexts/ContentfulContext';

const ManageContentfulIntegration = () => {
  const { content } = useContentfulContext();

  return (
    <main id="main" className="stride-page-shell flex flex-col space-y-6">
      <div>
        <span className="stride-eyebrow">Setup / Integrations</span>
        <h1 className="text-2xl font-bold tracking-tight text-stride-heading">
          {content.CONTENTFUL_CONTENT.title}
        </h1>
        <p className="text-sm text-stride-muted mt-1">
          {content.CONTENTFUL_CONTENT.description}
        </p>
      </div>
      <div className="w-full">
        <ContentfulIntegrationTable />
      </div>
    </main>
  );
};

export default ManageContentfulIntegration;
